import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid';
import { Link } from 'gatsby';
import Chevron from '../../assets/icons/chevron_right.svg';
import isExternalLink from '../../util/isExternalLink'

const LinkList = ({ title, items, smallPadding }) => {
  return (
    <div className={`link-list ${smallPadding ? 'small-padding' : ''}`}>
      {title && <h2>{title}</h2>}
      <ul>
        {items.map(item => (
          <li key={uuid()}>
            {isExternalLink(item.url)
              ? (
                <a href={item.url}>
                  <Chevron />
                  {item.name}
                </a>
              )
              : (
                <Link to={item.url}>
                  <Chevron />
                  {item.name}
                </Link>
              )
            }
          </li>
        ))}
      </ul>
    </div>
  );
};

LinkList.defaultProps = {
  title: 'Veel gezocht',
  items: [
    {
      name: 'Activeren DigiD lukt niet',
      url: '#',
    },
    {
      name: 'Hoe vraag ik een DigiD aan?',
      url: '#',
    },
    {
      name: 'Ik wil iemand machtigen',
      url: '#',
    },
  ],
};

LinkList.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object),
};

export default LinkList;
